<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" scrollable no-close-on-esc no-close-on-backdrop>
            <tire-reference-model-create-or-update v-model="tireReferenceModel" :tireSizes="tireSizes" :axles="axles"></tire-reference-model-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    name="tire-reference"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    selectable
                    v-on:select="selecteds = $event"
                    search
                    :items-provider="provider">
                    <template #additional-actions>
                        <div class="row">
                            <div class="col-auto">
                                <button class="btn btn-success" v-on:click="setNewValuesForMultiple" :disabled="selecteds.length == 0">
                                    {{selecteds.length}} Seçilenleri Güncelle
                                </button>
                            </div>
                        </div>
                    </template>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import CalculatePriceApi from '@/api/calculate-price'
import VehicleDefinitionsApi from '@/api/vehicle-definitions'
import moment from "moment"
import TireReferenceModelCreateOrUpdate from './components/TireReferenceModelCreateOrUpdate.vue'
import TireReferenceModelMultipleUpdate from './components/TireReferenceModelMultipleUpdate.vue'
export default {
    components:{
        BCard,
        TireReferenceModelCreateOrUpdate,
        TireReferenceModelMultipleUpdate
    },
    data() {
        return {
            editing:false,
            erorrs:{},
            loading:false,
            tireReferenceModel:{
                Id:null,
                Name:null,
                EffectiveDates: [],
                TireReferenceModelAxleInfos:[],
                TireSizeId:null
            },
            fields:[
                { name:"Model Adı",key:"Name",thClass:"w-20",tdClass:'text-nowrap',sortable:true},
                { name:"Lastik Ebat",key:"TireSize",thClass:"w-20",tdClass:'text-nowrap',sortable:true},                
                { name:"Geçerli Fiyat Başlangıç Tarihi",key:"CurrentEffectiveDate",thClass:"w-10",tdClass:'text-nowrap text-success font-weight-bold',sortable:false},
                { name:"Geçerli Fiyat (TL)",key:"CurrentPrice",thClass:"w-10",tdClass:'text-nowrap text-success font-weight-bold',sortable:false},
                { name:"Güncel Fiyat Başlangıç Tarihi",key:"NextEffectiveDate",thClass:"w-20",tdClass:'text-nowrap',sortable:false},
                { name:"Güncel Fiyat (TL)",key:"NextPrice",thClass:"w-20",tdClass:'text-nowrap',sortable:false},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            selecteds:[],
            axles:[
                {PartLocation:"FRONT",AxleOrder:1,active:false},
                {PartLocation:"FRONT",AxleOrder:2,active:false},
                {PartLocation:"FRONT",AxleOrder:3,active:false},
                {PartLocation:"FRONT",AxleOrder:4,active:false},
                {PartLocation:"BACK",AxleOrder:1,active:false},
                {PartLocation:"BACK",AxleOrder:2,active:false},
                {PartLocation:"BACK",AxleOrder:3,active:false},
                {PartLocation:"BACK",AxleOrder:4,active:false},
            ],
            tireSizes:[]
        }
    },
    mounted(){
        this.getTireSizes()
    },
    methods:{
        clearForm(){
            this.editing = false
            this.tireReferenceModel.Id = null,
            this.tireReferenceModel.TireSizeId = null
            this.tireReferenceModel.Name = null
            this.tireReferenceModel.EffectiveDates = []
            this.tireReferenceModel.TireReferenceModelAxleInfos = []
            this.axles.forEach(a => { a.active = false })
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            CalculatePriceApi.TireReferenceModel.CreateOrUpdate(this.editing,this.tireReferenceModel)
            .then(res => {
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
                this.loading = false
            }).catch(error => {
                this.loading = false
                this.$result(null,error)
            })
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.tireReferenceModel.Id = item.Id
            this.tireReferenceModel.TireSizeId = item.TireSizeId
            this.tireReferenceModel.Name = item.Name,
            this.axles.forEach(a => { a.active = item.TireReferenceModelAxleInfos.find(tr=> tr.PartLocation == a.PartLocation && tr.AxleOrder == a.AxleOrder)? true : false });
            this.tireReferenceModel.TireReferenceModelAxleInfos = item.TireReferenceModelAxleInfos,
            this.tireReferenceModel.EffectiveDates = item.EffectivePrices.map(d=>{
                return { 
                    Price: d.Price,
                    EffectivePriceDate: d.EffectivePriceDate,
                    EffectivePriceDateVisual: moment(d.EffectivePriceDate).locale("tr").format('L'), 
                    Id: d.Id
                }
            })
            this.$showModal('create-or-update')
        },
        provider(data){
            return CalculatePriceApi.TireReferenceModel.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} lastik referans modelini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    CalculatePriceApi.TireReferenceModel.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        setNewValuesForMultiple(){
            this.$showModal('multiple-update')
        },
        updateMultiple(){
            this.loading = true
            CalculatePriceApi.TireReferenceModel.UpdateMultiple(this.selecteds)
            .then(res=>{
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('multiple-update')
                    this.$refs.table.refresh()
                }
                this.loading = false
            }).catch(error=>{
                this.loading = false
                this.$result(null,error)
            })
        },
        getTireSizes(){
            VehicleDefinitionsApi.TireSize.List().then(res => {
                if(res.data.Success){
                    this.tireSizes = res.data.Data
                }
                
            }).catch(error => {
                
            })
        }
    }
}
</script>

<style>

</style>